import { gql } from '@common/hooks';
import { WorksUsersSelect } from 'works/components/form-fields/works-users-select';

export const ASSIGNMENT_TERM_QUERY = gql`
  query assignmentTerm($id: ID!) {
    assignmentTerm(id: $id) {
      id
      startDate
      endDate
      effectiveAt
      employmentType
      timeoffDescription
      shiftType
      hoursPerShift
      shiftsPerWeek
      overtimeThreshold
      canEditEndDateToPast
      canEditEndDateToFuture
      canEditStartDate
      billingRegularRate
      organizationUnit {
        id
        name
        department {
          id
        }
      }
      hiringLeader {
        id
        name
      }
      staffingRequestAssignment {
        id
        state
      }
    }
  }
`;

export const ASSIGNMENT_TERM_MUTATION = gql`
  mutation UpsertAssignmentTerm(
    $input: UpsertAssignmentTermInput!
    $assignmentTermId: ID!
  ) {
    upsertAssignmentTerm(input: $input, assignmentTermId: $assignmentTermId) {
      assignmentTerm {
        id
        effectiveAt
        timeoffDescription
        shiftType
        hoursPerShift
        shiftsPerWeek
        startDate
        endDate
        billingRegularRate
        overtimeThreshold
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

export const ASSIGNMENT_SOURCE_MUTATION = gql`
  mutation UpdateAssignmentTermsSource(
    $input: UpdateAssignmentTermsSourceInput!
    $assignmentTermId: ID!
  ) {
    updateAssignmentTermsSource(
      input: $input
      assignmentTermId: $assignmentTermId
    ) {
      assignmentTerm {
        id
        startDate
        endDate
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

export const WORKS_USERS_QUERY = gql`
  query WorksUsers($departmentId: ID) {
    worksUsers(departmentId: $departmentId) {
      id
      ...WorksUsersSelectFragment
    }
  }
  ${WorksUsersSelect.fragment}
`;
